import { Card } from '@/widgets/layouts/main/slider-cards/slider-card/types';
export const CARDS: Card[] = [{
  title: 'Для работы',
  description: 'Прокачиваем коммуникацию для свободного общения на любые рабочие темы',
  points: [{
    text: 'Для тех, кто хочет развиваться в международной карьере'
  }, {
    text: 'Для digital, it, менеджеров и других профессий'
  }, {
    text: 'Группы уровней А2-В2'
  }],
  badges: [{
    text: '3 месяца'
  }, {
    text: 'обсуждение рабочих кейсов'
  }, {
    text: '1000 ₽/урок'
  }],
  key: 'work'
}, {
  title: 'Для собеседований',
  description: 'Поможем подготовиться к собеседованию на английском',
  points: [{
    text: 'Для любых профессий'
  }, {
    text: 'Составим CV, LinkedIn, сопроводительные письма'
  }, {
    text: 'Отработаем все возможные вопросы с собеседований'
  }],
  badges: [{
    text: 'mock interview с носителем'
  }, {
    text: '3 месяца'
  }, {
    text: '1200 ₽/урок'
  }],
  key: 'interview'
}, {
  title: 'С нуля за 3 месяца',
  description: 'Только нужная грамматика и лексика, чтобы начать говорить на первых занятиях',
  points: [{
    text: 'Подойдет для тех, кому нужен язык для работы/ путешествий / переезда и просто для жизни'
  }, {
    text: 'Практика спикинга с первых занятий'
  }],
  badges: [{
    text: '3 месяца'
  }, {
    text: 'курс-интенсив'
  }, {
    text: '1000 ₽/урок'
  }],
  key: 'beginner'
}, {
  title: 'Для профи',
  description: 'Говорите как носитель, звучите профессионально',
  points: [{
    text: 'Грамматика и лексика высоких уровней (В2-С2)'
  }, {
    text: 'Спикинг с носителями языка'
  }, {
    text: 'Обсуждаем рабочие кейсы, дебаты, презентации и многое другое'
  }],
  badges: [{
    text: '3 месяца'
  }, {
    text: 'носитель языка'
  }],
  key: 'pro'
}, {
  title: 'Общий английский',
  description: 'Язык для повседневного общения, путешествий, саморазвития',
  points: [{
    text: 'Актуальные темы современного мира'
  }, {
    text: '+ уровень языка за 3-6 месяцев'
  }, {
    text: '80% урока - спикинг'
  }],
  badges: [{
    text: '1000 ₽/урок'
  }, {
    text: 'все уровни'
  }, {
    text: 'много спикинга'
  }],
  key: 'common'
}];